export class AgentStatus {
  constructor(
    public content: string,
  ) {}
}
